import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {ReactComponent as EyeIcon} from "assets/img/svg/eyeIcon.svg"
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import moment from "moment";
import { Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import ALoader from 'views/pages/manage/common/a-loader';
import { logsList } from './constant';
import LogsDialoge from './LogsDialoge';
import { Card, CardBody } from 'reactstrap';
const Logs=({
    selectedTabValue,
    dropdowns,
    buId})=>{

const [logsDialogeInfo, setLogsDialogeInfo] = useState();
const [loader, setLoader] = useState(false)
const columns=[
    new AGridColDef("tabName", "Type", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
              params?.value ? <Tooltip title={params?.value}>
                <div className={`ellipsis-text-container`}>{params?.value}</div>
              </Tooltip> : <div>-</div>
            )),
            new AGridColDef("logs", "Logs", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
              <div><EyeIcon onClick={()=>{setLogsDialogeInfo(params?.row)}}/></div>
            )),
           
]
if (selectedTabValue?.id !== 10) return null;
    return(
           <Card className='ml-0'>
                <CardBody>
                    <h3>Logs</h3>
               <div className="" style={{border:'1px solid #EEE', borderRadius:'8px'}}>
                    <ADataGrid
                      removeWrapperContainer
                      rowModesModel
                      rows={logsList || []}
                      columns={columns}
                      rowId={(row) =>JSON.stringify(row)}
                      rowHeight={50}
                      rowCount={logsList.length}
                      loading={false}
                      components={{
                        ...gridComponents,
                        NoRowsOverlay: () => (
                          <NoRowOverlay message={loader ? "Loading..." : null} />
                        ),
                      }}
                      sx={{
                        ...gridStyles,
                      }}
                      autoHeight
                      hidePagination={true}
                    />
                  </div>
                  {logsDialogeInfo&&<LogsDialoge
                  setLogsDialogeInfo={setLogsDialogeInfo}
                  logsDialogeInfo={logsDialogeInfo}
                  buId={buId}
                  dropdowns={dropdowns}
                  />}

                   </CardBody>
            </Card>
    )
}
export default Logs;